"use client";

import React, { useCallback, useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import log from "logbeacon";
import { useOspLogin } from "@/src/features/auth/compat/useOspLogin";
import { FloatingPopup } from "../FloatingPopup";
import { useGuideModal } from "../../hooks/useGuideModal";
import { LoginGuideContent } from "./LoginGuideContent";
import { LoginGuidePopupProps } from "./types";
import { GuideModalType } from "@/src/utils/guideModalStorage";
import { rootStore } from "@/src/store";

export const LoginGuidePopup: React.FC<LoginGuidePopupProps> = ({
  config,
  parentRef,
}) => {
  const [isStartLoading, setIsStartLoading] = useState(true);
  const { isWeb3Fetching } = useOspLogin();
  // 使用增强的Hook获取弹窗状态和控制方法
  const { shouldShow, dismissModal, isLoading } = useGuideModal({
    ...config,
    modalType: GuideModalType.LOGIN_GUIDE,
  });
  const { isLoggedIn } = useSnapshot(rootStore.login);
  // 安全的关闭处理函数
  const handleClose = useCallback(() => {
    try {
      dismissModal();
    } catch (error) {
      log.error("[LoginGuide] Error closing login guide popup:", error);
    }
  }, [dismissModal]);

  useEffect(() => {
    if (isStartLoading && !isLoading && !isLoggedIn && !isWeb3Fetching) {
      setTimeout(() => {
        setIsStartLoading(false);
      }, 500);
    }
  }, [isStartLoading, isLoggedIn, isLoading, isWeb3Fetching]);

  if (isStartLoading && !isLoggedIn) {
    return null;
  }

  // 如果正在加载，正在登录，已经登录不显示弹窗
  if (isLoading || isLoggedIn || isWeb3Fetching) {
    return null;
  }

  // 如果不应该显示，不渲染
  if (!shouldShow) {
    return null;
  }

  return (
    <FloatingPopup
      open={shouldShow}
      onClose={handleClose}
      parentRef={parentRef}
      widthMode={"centered"}
    >
      <LoginGuideContent />
    </FloatingPopup>
  );
};
